export default __webpack_public_path__ + "static/media/hushpuppiesCover.61282d96.jpg";